// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /award/get-for-member.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeAwardGetForMemberBody,
  typeAwardGetForMemberOutput200,
} from "../../sdk/award/postAwardGetForMember";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildAwardGetForMemberQueryKey(
  payload: typeAwardGetForMemberBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`poolId:${JSON.stringify(payload.poolId)}`);
  queryKeySegments.push(`targetUserId:${JSON.stringify(payload.targetUserId)}`);
  return [
    "post:award:awardGetForMember",
    "svc:contest-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeAwardGetForMemberOutput200,
    unknown,
    typeAwardGetForMemberOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useAwardGetForMember(
  payload: typeAwardGetForMemberBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildAwardGetForMemberQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postAwardGetForMember(payload),
    ...resolvedOptions,
  });
}
